import { useRef, useState } from "react";

const useUploadMultipleImage = () => {
  const [images, setImages] = useState([{}, {}, {}]);

  const removeImage = (i) => {
    setImages(images?.map((image, index) => (index === i ? {} : image)));
  };

  const imageRef = useRef();

  const onChange = (e, i) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => setImages(images?.map((image, index) => (index === i ? { file, url: reader.result } : image)));
    reader.readAsDataURL(file);
    e.target.value = null;
  };

  return { onChange, imageRef, images, removeImage };
};

export default useUploadMultipleImage;
